import React from 'react';

import {
	UseReactiveFormInput,
	UseReactiveFormOutput as UseReactiveFormOutputShared,
	UseReactiveFormInputPropsOutput as UseReactiveFormInputPropsOutputShared,
} from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/$types';
import { useReactiveForm as useReactiveFormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/hooks';

type actionEvent = 'onChange' | 'showErrors' | 'onFocus' | 'onBlur' | 'error';
export interface UseReactiveFormInputPropsOutput extends Omit<UseReactiveFormInputPropsOutputShared, actionEvent> {
	status: 'default' | 'error';
	bottomMessage: {
		text: {
			content: string;
		};
	};
	debounce: number;
	// onBlur: () => void;
	onChangeValue: (value: string) => void;
	// onFocus: () => void;
	onBlur: (blurred: boolean) => void;
	onFocus: (focused: boolean) => void;
}

export interface UseReactiveFormOutput extends Omit<UseReactiveFormOutputShared, 'getInputProps'> {
	getInputProps: (name: string) => UseReactiveFormInputPropsOutput;
}

export const useReactiveForm = (props: UseReactiveFormInput): UseReactiveFormOutput => {
	const { name: formName, initialValues, options, validations, validate, onSubmit } = props;
	const reactiveForm = useReactiveFormShared({
		name: formName,
		onSubmit,
		initialValues,
		options,
		validate,
		validations,
	});
	const inputStatus = React.useRef<Record<string, 'default' | 'focused' | 'blurred'>>({});
	const handleGetInputProps = React.useCallback(
		(name: string): UseReactiveFormInputPropsOutput => {
			const { error, onBlur, onChange, onFocus, value, showErrors } = reactiveForm.getInputProps(name);

			return {
				name,
				status: showErrors && error ? 'error' : 'default',
				onChangeValue: onChange,
				value,
				bottomMessage: {
					text: {
						content: showErrors && error ? error : '',
					},
				},
				debounce: 0,
				// onBlur: (): void => {
				// 	onBlur();
				// },
				// onFocus: (): void => {
				// 	onFocus();
				// },
				onBlur: (blurred: boolean): void => {
					if (blurred && inputStatus.current[name] !== 'blurred') {
						inputStatus.current[name] = 'blurred';
					}
					onBlur();
				},
				onFocus: (focused: boolean): void => {
					if (focused && inputStatus.current[name] !== 'focused') {
						inputStatus.current[name] = 'focused';
					}
					onFocus();
				},
			};
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[reactiveForm]
	);

	return {
		...reactiveForm,
		getInputProps: handleGetInputProps,
	};
};
